<template>
  <div>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               :row-class-name="rowClass"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
      <!-- 自定义列表多功能栏 -->
      <table-column-set :THIS_TO_PARENT="this"
                        slot="menuRight"/>
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   v-if="permission['login-log_delete']"
                   @click="handleDelete">删除
        </el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import {getList, getDetail, remove} from "@/api/login-log";
import crudmixins from "@/basic-common/mixins/crudmixins.js";
import {mapGetters} from "vuex";

const mixin = new crudmixins({getDetail, getList, remove})

export default {
  mixins: [mixin],
  data() {
    return {
      option: {
        ...this.$store.state.publicOption,
        menuWidth: 120, //操作列宽度
        column: [
          {
            label: "登录账号",
            prop: "loginName",
            overHidden: true,
            type: "input",
            search: true,
            maxlength: 100,
          },
          {
            label: "客户端IP",
            prop: "clientIp",
            overHidden: true,
            type: "input",
            search: true,
            maxlength: 128,
          },
          {
            label: "登录地点",
            prop: "loginLocation",
            overHidden: true,
            type: "input",
            maxlength: 100,
          },
          {
            label: "浏览器类型",
            prop: "browser",
            overHidden: true,
            type: "input",
            maxlength: 50,
          },
          {
            label: "操作系统",
            prop: "os",
            overHidden: true,
            type: "input",
            maxlength: 50,
          },
          {
            label: "类型",
            prop: "loginType",
            overHidden: true,
            width: 80,
            type: "radio",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=login_logout_flag",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            search: true,
          },
          {
            label: "状态",
            prop: "status",
            type: 'select',
            search: true,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
            width: 80,
            dataType: 'string',
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=success_fail_flag",
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: "操作信息",
            prop: "remark",
            overHidden: true,
            type: "textarea",
            maxlength: 200,
          },

          {
            label: "登录/退出时间",
            prop: "createTime",
            width: 155,
            showColumn: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: "查询时间",
            prop: "searchDate",
            type: "datetime",
            dataType: 'string',
            hide: true,
            showColumn: false,
            search: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            searchValue: "",
            dateDefault: true,
            overHidden: true,
            searchRange: true,
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
          },
        ]
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: this.vaildData(this.permission['login-log_view'], false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {}
};
</script>

<style>
</style>
  